<template>
    <div class="col-group">
        <TaxinummerLink date="Januari 2011" nummer="6" />
        <TaxinummerLink date="Februari 2011" nummer="7" />
        <TaxinummerLink date="Maart 2011" nummer="8" />
        <TaxinummerLink date="April 2011" nummer="9" />
        <TaxinummerLink date="Mei 2011" nummer="10" />
        <TaxinummerLink date="Juni 2011" nummer="11" />
        <TaxinummerLink date="Juli 2011" nummer="12" />
        <TaxinummerLink date="Sept-Ok 2011" nummer="13" />
        <TaxinummerLink date="Okt-Nov 2011" nummer="14" />
        <TaxinummerLink date="Nov-Dec 2011" nummer="15" />
        <TaxinummerLink date="December 2011" nummer="16" />
    </div>
</template>

<script>
import TaxinummerLink from '@/components/TaxinummerLink';

export default{
    name: 'magazine-2011',
    components: {
        'TaxinummerLink': TaxinummerLink,
    }
}
</script>
